// extracted by mini-css-extract-plugin
export default {"card":"LoginCard_card__frE5w"};